import { render } from "./empty-state-simple.vue?vue&type=template&id=48bb06ce"
import script from "./empty-state-simple.vue?vue&type=script&lang=js"
export * from "./empty-state-simple.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__